import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';

const IsLoggedIn: FC = () => {
  const { session, user, isLoading } = useAuthContext();
  const ADMIN_DASHBOARD_ROOT = '/admin-dashboard';
  const isInAdminDashboard = location.pathname.startsWith(ADMIN_DASHBOARD_ROOT);
  const isResident = user?.role === 'resident';
  const isVendor = user?.role === 'vendor';
  const isAdmin = user?.email?.endsWith('@vendrpal.ai') && user?.role === 'admin';

  if (isLoading) {
    return null;
  }

  if (!session || !user) {
    return <Navigate to={Routes.LOGIN} replace />;
  }
  if (!session.user.email_confirmed_at) {
    return <Navigate to={Routes.CONFIRM_EMAIL} replace />;
  }

  if (isAdmin) {
    if (!isInAdminDashboard) {
      return <Navigate to={Routes.ADMIN_BUILDINGS} replace />;
    }
  }
  if (isResident) {
    if (location.pathname !== Routes.RESIDENT_ONBOARDING) {
      return <Navigate to={Routes.RESIDENT_ONBOARDING} replace />;
    }
  }
  if (isVendor) {
    if (location.pathname !== Routes.VENDOR_ONBOARDING) {
      return <Navigate to={Routes.VENDOR_ONBOARDING} replace />;
    }
  }

  return <Outlet />;
};

export default IsLoggedIn;
